exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".blur-box-active{-webkit-filter:blur(10px);filter:blur(10px)}.blur-box-active,.blur-box-deactive{width:auto;height:auto}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/BlurBox/style.css"],"names":[],"mappings":"AAAA,iBAGE,0BAA2B,AAC3B,iBAAmB,CACpB,AAED,oCANE,WAAY,AACZ,WAAa,CAQd","file":"style.css","sourcesContent":[".blur-box-active {\n  width: auto;\n  height: auto;\n  -webkit-filter: blur(10px);\n  filter: blur(10px);\n}\n\n.blur-box-deactive {\n  width: auto;\n  height: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Components/BlurBox/style.css
// module id = 446
// module chunks = 6 7